'use client';

import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { getIsServerEnv } from '@/shared/modules/environment';
import { CopyButton } from '../copy-button';
import { ShareButton } from '../share-button';
import * as Styled from './copyable-text-component.styled';
export const CopyableTextComponent = React.memo(function CopyableTextComponent() {
  const {
    strings
  } = useEdgeConfigWidget(WidgetId.CopyableText);
  const urlWithQuery = getIsServerEnv() ? strings.clipboardText : window.location.href;
  return <Styled.Wrapper>
      <Styled.Title>{strings.title}</Styled.Title>
      <Styled.Subtitle>{strings.subtitle}</Styled.Subtitle>
      <Styled.CopyHelp>{strings.copyHelpText}</Styled.CopyHelp>
      <CopyButton clipboardText={urlWithQuery} />
      <ShareButton shareUrl={urlWithQuery} shareText={strings.shareButtonText} />
    </Styled.Wrapper>;
});